import Button from '../sydo/prefab/buttons/Button.js';
import { Colors } from '../consts/Colors.js';
import { Sizes } from '../consts/Sizes.js';

export default class ButtonLoupe extends Button {
    constructor(scene, x, y, text = 'Chercher') {
        var params = {
            width: 200,
            height: 64,
            text: text,
            text_color: Colors.Text.White,
            box_color: Colors.Elmt.BleuNovotel,
            icon: 'loupe',
        };

        super(scene, x, y, params);
    }

    addBody(params) {
        // Ajout fond
        this.back = this.scene.add.rexRoundRectangle(
            0,
            0,
            params.width,
            params.height,
            params.height / 2,
            params.box_color
        );
        this.back.setOrigin(0.5);
        this.add(this.back);

        this.icon = this.scene.add.image(params.width / 2 - 40, 0, params.icon).setOrigin(0.5);
        this.add(this.icon);

        this.text = this.scene.add
            .rexTagText(-params.width / 2 + 20, 0, params.text, {
                fontSize: '24px',
                fontFamily: 'Monteserrat',
                align: 'left',
                color: params.text_color,
                backgroundColor: 'transparent',
            })
            .setOrigin(0, 0.5); // ← aligné à gauche
        this.add(this.text);

        // Ajout interaction
        this.setSize(this.back.width, this.back.height);

        this.setInteractive({ useHandCursor: true });
        this.on('pointerover', this.pointerOver, this);
        this.on('pointerout', this.pointerOut, this);
    }
}
